/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relaunch_Learning_StartInputs */



/**
* | output |
* | --- |
* | "Start" |
*
* @param {Relaunch_Learning_StartInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const relaunch_learning_start = /** @type {((inputs?: Relaunch_Learning_StartInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relaunch_Learning_StartInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Start")
	return /** @type {LocalizedString} */ ("Lancer")
});